export default "__VITE_ASSET__DQSCrmch__"